import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

export function DemoVideo({ className = "" }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);

  const start = () => {
    const v = ref.current;
    if (!v) return;
    setPlaying(true);
    v.play().catch(() => setPlaying(false));
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.35, duration: 0.6 }}
      id="demo-video"
      className={`relative ${className}`}
      data-testid="demo-video"
    >
      <div className="pointer-events-none absolute -inset-6 rounded-[2rem] bg-brass/10 blur-3xl" />
      <div className="relative rounded-2xl border border-white/10 bg-[#0b1a35] shadow-2xl shadow-black/40 overflow-hidden">
        <div className="flex items-center gap-1.5 px-4 h-9 border-b border-white/5 bg-white/[0.03]">
          <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
          <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
          <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
          <span className="ml-3 text-[11px] font-mono uppercase tracking-wider text-slate-400">Casanéo · démo 1 min</span>
        </div>
        <div className="relative aspect-video bg-black">
          <video
            ref={ref}
            poster="/casaneo-demo-poster.webp"
            controls={playing}
            playsInline
            preload="metadata"
            onEnded={() => setPlaying(false)}
            className="h-full w-full"
            data-testid="demo-video-player"
          >
            <source src="/casaneo-demo.mp4" type="video/mp4" />
            <source src="/casaneo-demo.webm" type="video/webm" />
          </video>
          {!playing && (
            <button
              type="button"
              onClick={start}
              aria-label="Lire la démo"
              data-testid="demo-video-play"
              className="group absolute inset-0 flex items-center justify-center bg-[#071e42]/35 hover:bg-[#071e42]/20 transition-colors"
            >
              <span className="flex items-center gap-3 rounded-full bg-brass text-[#0b1a35] pl-4 pr-6 py-3 font-semibold shadow-xl shadow-brass/30 transition-transform group-hover:scale-105">
                <span className="grid place-items-center h-9 w-9 rounded-full bg-[#0b1a35] text-brass">
                  <Play className="h-4 w-4 ml-0.5 fill-current" />
                </span>
                Voir la démo
              </span>
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
}
